import { SUPPORTED_LOCALES } from '@/constants/locale';

export function convertLocale(lang?: string) {
  if (!lang) return 'en-US';

  const normalizedLang = lang.replace(/_/g, '-').toLowerCase();
  if (normalizedLang === 'zh') return 'zh-CN';
  if (['zh-hk', 'zh-tw', 'zh-hant'].includes(normalizedLang)) return 'zh-HK';

  const [primary] = normalizedLang.split('-');
  const matchedLocale = SUPPORTED_LOCALES.find((locale) => {
    return locale.toLowerCase().startsWith(primary);
  });

  return matchedLocale || 'en-US';
}

export function getDefaultLocale() {
  const urlParams = new URLSearchParams(window.location.search);
  let lang = urlParams.get('lenovoid.lang') || urlParams.get('lang');

  if (!lang) {
    const storedLang = localStorage.getItem('i18Lng');
    if (storedLang) {
      lang = storedLang;
    }
  }

  const finalLang = lang || navigator?.language;

  return convertLocale(finalLang);
}
